// extracted by mini-css-extract-plugin
export default {"ConfirmationPop":"ConfirmationPop_ConfirmationPop__-0ehx","modalBody":"ConfirmationPop_modalBody__ecCPM"};